// 角色管理
export default {
    role: '角色',
    roleName: '角色名称',
    roleDescription: '角色说明',
    userNumber: '用户数',
    editRole: '编辑角色',
    addRole: '添加角色',
    rolePermissions: '角色权限',
    tip_delete: '角色被删除后，将无法恢复，请请谨慎操作！<br/>（该角色的原有用户仅拥有首页查看功能）',
}